/* ============================================================
   KS BACK TO TOP
   Erscheint ab 300px Scroll, smooth scroll nach oben.
   ============================================================ */

(function () {
  'use strict';

  const SCROLL_THRESHOLD = 300;

  const btn = document.createElement('button');
  btn.id = 'ks-back-to-top';
  btn.setAttribute('aria-label', 'Nach oben scrollen');
  btn.innerHTML = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <polyline points="18 15 12 9 6 15"></polyline>
  </svg>`;

  document.body.appendChild(btn);

  let ticking = false;

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        if (window.scrollY > SCROLL_THRESHOLD) {
          btn.classList.add('is-visible');
        } else {
          btn.classList.remove('is-visible');
        }
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();